import { render, staticRenderFns } from "./SwapExercise.vue?vue&type=template&id=63a61620&"
import script from "./SwapExercise.vue?vue&type=script&lang=js&"
export * from "./SwapExercise.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports